"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = Page;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _state = require("../../../state");
var _ui = require("../../ui");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function Page(_ref) {
  var loginPath = _ref.loginPath;
  var _useParams = (0, _reactRouterDom.useParams)(),
    key = _useParams.key;
  var _useConfirmEmail = (0, _state.useConfirmEmail)(),
    done = _useConfirmEmail.done,
    loading = _useConfirmEmail.loading,
    confirmEmail = _useConfirmEmail.confirmEmail;
  (0, _react.useEffect)(function () {
    confirmEmail(key);
  }, []);
  if (done) return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: loginPath
  });
  return loading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "w-100 d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_ui.Spinner, {
    color: "primary"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
}